import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass([
      'size-35 rounded-xl cursor-pointer',
      'border border-dashed border-neutral2-300',
      'flex justify-center items-center',
      'relative'])
}
const _hoisted_3 = {
  key: 0,
  textContent: 'Przesyłanie...'
}

import {computed, ref} from 'vue';
import Icon from "../Icon/Icon.vue";
import {UploadImage} from "../UploadImage";

interface Props {
  upload: UploadImage;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageUpload',
  props: /*@__PURE__*/_mergeModels({
    upload: { type: Function }
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const imageUrl = _useModel<string|null>(__props, "modelValue");
const uploading = ref<boolean>(false);
const hasImage = computed(() => !!imageUrl.value);

function fileChanged(event: Event): void {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    uploadFile(file);
    event.target.value = '';
  }
}

function uploadFile(file: File): void {
  uploading.value = true;
  props.upload(file)
    ?.then((uploadedImageUrl: string) => {
      imageUrl.value = uploadedImageUrl;
    })
    ?.finally(() => {
      uploading.value = false;
    });
}

function removeImage(event: Event): void {
  imageUrl.value = null;
  event.preventDefault();
}

return (_ctx: any,_cache: any) => {
  return (hasImage.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "size-35 rounded-xl",
        onClick: removeImage
      }, [
        _createElementVNode("img", {
          src: imageUrl.value!,
          alt: "Uploaded image",
          class: "object-cover size-full rounded-xl"
        }, null, 8 /* PROPS */, _hoisted_1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "file",
          accept: "image/jpeg,image/png",
          onChange: fileChanged,
          class: "absolute opacity-0 size-full left-0 top-0 cursor-pointer"
        }, null, 32 /* NEED_HYDRATION */),
        (uploading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : (_openBlock(), _createBlock(Icon, {
              key: 1,
              name: "jobOfferUploadCompanyLogo",
              class: "text-2xl"
            }))
      ]))
}
}

})